import React from 'react'
import PropTypes from 'prop-types'
import { useModel, useOperation } from '@morningtrain/react-resources'
import { autorun } from 'mobx'

export default function CanUseModel ({
  permission,
  negate = false,
  children
}) {
  const model = useModel()
  const operation = useOperation()

  const canCheck = (permission, model) => {
    return operation.can(permission, model)
  }

  const check = (permission, model) => {
    return negate ? !canCheck(permission, model) : canCheck(permission, model)
  }

  const [shouldRender, setShouldRender] = React.useState(check(permission, model))

  React.useEffect(() => {
    const disposer = autorun(() => {
      const shouldRenderCheck = check(permission, model)

      if (shouldRenderCheck !== shouldRender) {
        setShouldRender(shouldRenderCheck)
      }
    }, { fireImmediately: true })

    return () => {
      disposer()
    }
  }, [shouldRender, negate, operation, permission, model])

  return shouldRender ? children : null
}

CanUseModel.propTypes = {
  negate: PropTypes.bool,
  permission: PropTypes.string.isRequired
}
